/**
 * Utility function for retry logic with exponential backoff
 * Similar to XState's fromRetry but with more control over error handling
 */
export async function retryWithBackoff(fn, options) {
    let lastError;
    for (let attempt = 0; attempt < options.maxAttempts; attempt++) {
        try {
            return await fn();
        }
        catch (error) {
            lastError = error;
            console.log(`Attempt ${attempt + 1} failed:`, error);
            const retryResult = options.shouldRetry(error);
            if (retryResult !== true) {
                // shouldRetry returned a value other than true, return it
                return retryResult;
            }
            // Don't retry on last attempt
            if (attempt === options.maxAttempts - 1) {
                throw error;
            }
            // Calculate delay with exponential backoff
            const delay = Math.pow(2, attempt) * 1000; // 1s, 2s, 4s
            console.log(`Retrying in ${delay}ms...`);
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
    throw lastError;
}
